import { get } from 'lodash/fp';

export const getEstimateInvoices = get('estimateInvoices.list');
